import React from 'react';
import { isRequired } from '../../../utils/validation';
import IconArrowDown from '../../icons/IconArrowDown';

export const initialValues = {
  period: '',
  reason: '',
  photo: '',
};

export const fieldsProps = {
  period: {
    name: 'period',
    placeholder: 'Pilih Periode Suspend',
    label: 'Periode Suspend',
    data: [
      { label: 'Batas Waktu Tertentu', value: 'Batas Waktu Tertentu' },
      { label: 'Tanpa Batas Waktu', value: 'Tanpa Batas Waktu' },
    ],
  },
  dates: {
    valueFormat: 'MMM DD',
    locale: 'id',
    rightSection: <IconArrowDown />,
  },
  reason: {
    name: 'reason',
    placeholder: 'Tulis Alasan',
    label: 'Alasan Suspend',
    rows: 8,
  },
  photo: {
    name: 'photo',
    label: 'Upload Gambar',
  },
};

export const validate = (values = initialValues) => {
  const { period, reason } = values;
  const rules = {
    period: isRequired(period, 'Periode Suspend harus dipilih'),
    reason: isRequired(reason, 'Alasan Suspend harus diisi'),
  };

  return rules;
};
